// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingEventLogSearchResponse

import { hydrateBookingEventLog, type BookingEventLog, type BookingEventLogApiResponse } from './bookingEventLog.gen';

export type BookingEventLogSearchApiResponse = {
	items: BookingEventLogApiResponse[];
	total: number;
};

export type BookingEventLogSearch = {
	items: BookingEventLog[];
	total: number;
};

export function hydrateBookingEventLogSearch(data: BookingEventLogSearchApiResponse): BookingEventLogSearch {
	return {
		...data,
		items: data.items.map(hydrateBookingEventLog),
	};
}